import ReactDOM from "react-dom/client";
import App from "./App";

const rootEl = document.getElementById("root");

if (rootEl.hasChildNodes()) {
  ReactDOM.hydrateRoot(rootEl, <App />);
} else {
  ReactDOM.createRoot(rootEl).render(<App />);
}
